import axios from 'axios';
import { authProvider } from '../../utils/authProvider';


export async function updateAxiosToken() {
  const token = await authProvider.getAccessToken();
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.accessToken;
}
